import { BillTimeOffSourceType } from '../types';

export const TIME_OFF_SOURCE_LABEL_KEYS: Record<BillTimeOffSourceType, string> = {
  [BillTimeOffSourceType.APPROVED]: 'authenticated.bills:timeOffSource.approved',
  [BillTimeOffSourceType.PENDING]: 'authenticated.bills:timeOffSource.pending',
  [BillTimeOffSourceType.APPROVED_AND_PENDING]:
    'authenticated.bills:timeOffSource.approvedAndPending',
};
